module.exports = __webpack_public_path__ + "static/cn-edf4cc5ff868e2e207af34f2406ddf11.gif";